// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 35 ? "f31aec94" : chunkId) + "." + {"35":"d228b2996bbb0d2d","36":"e935ca1f9bc2d737","85":"fb5d517f13849e07","193":"a04f684e4ac0b9f8","228":"778bae214c45733d","709":"2f4bc70a65fac0e6","795":"94881c9635cc85aa"}[chunkId] + ".js";
};